// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"a8443eb1","436":"8fc8a257","453":"f394a27d","501":"5f4a3d85","606":"7819f8f5","925":"0edf19da"}[chunkId] + ".chunk.js";
};